import { render, staticRenderFns } from "./peer-front-facing-listing.component.vue?vue&type=template&id=5359468a&"
import script from "./peer-front-facing-listing.component.ts?vue&type=script&lang=ts&"
export * from "./peer-front-facing-listing.component.ts?vue&type=script&lang=ts&"
import style0 from "./peer-front-facing-listing.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports